module.exports = __webpack_public_path__ + "static/media/retirement-object-0-0-0.1657ae6b.png";